const TYPE = 'REGISTRATION_SET_DEVICE_VERIFIED';

const action = (verified) => (dispatch) => dispatch({ type: TYPE, payload: verified });

export default { action, TYPE };
